import { z } from 'zod';
import { FromSchema } from '../SchemaOperations';

export const PermissionsSchema = z
    .object({
        tenantId: z.string(),
        buyers: z.array(z.string()).optional(),
    })
    .strict();

export class Permissions extends FromSchema(PermissionsSchema) {
    tenantId: string;
    buyers?: string[];
}
